var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { styled, useTheme } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, CircularProgress, Container, FormControl, Grid, InputLabel, Select, TextField, Typography, Switch, FormGroup, FormControlLabel, Autocomplete, } from "@mui/material";
import { DownloadSimple, Plus, UserCheck } from "@phosphor-icons/react";
import React, { useContext, useState } from "react";
import LeadsApi from "../../../infrastructure/api/pages/lead-api";
import { useNavigate } from "react-router-dom";
import { UserRolesPermissionsContext } from "../../../context/UserRolesPermissionsContext";
import { checkCreateEdit, checkManage, } from "../../../application/common/utils/roles-helper";
import { Modules } from "../../../application/common/enums/screen-name";
import { toast } from "react-toastify";
import ImportLeadsErrorModal from "./ImportLeadsErrorModal";
import { getStatusOptionsForDropdown } from "../../../application/common/utils/lead-status-helper";
const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
export const LeadgenerationTopHeader = ({ title, hideActions, setSearch, setStatus, search, status, handleOpenModal, setRefresh, isSelectiveRoles, setIsSelectiveRoles, setPaginationModel, selectedPersonId, setSelectedPerson, isUnAssignedLeads, setIsUnAssignedLeads, contactOptions, }) => {
    var _a, _b;
    const { t: translate } = useTranslation();
    const theme = useTheme();
    const [searchInput, setSearchInput] = useState(search);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { RolesPermissions } = useContext(UserRolesPermissionsContext);
    // const [contactOptions, setContactOptions] = useState<option[]>([]);
    const handleSearch = (e) => {
        if (e.key === "Enter") {
            setPaginationModel({ page: 0, pageSize: 15 });
            setSearch(searchInput);
        }
    };
    const createNewLead = () => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        var lead = {
            contactName: "",
            totalObjects: 0,
            status: 0,
            isDeleted: false,
            phoneNumber: "",
            email: "",
            leadNumber: 0,
            informationSubmitted: false,
            responsiblePersonName: "",
            // hasContract:false
        };
        yield LeadsApi.createNewLead(lead)
            .then((res) => {
            if (res.data) {
                const id = res.data.id;
                const companyId = res.data.companyId;
                const orderNumber = res.data.leadNumber;
                const newUrl = `/lead-detail?${new URLSearchParams({
                    id,
                    companyId,
                    orderNumber,
                }).toString()}`;
                navigate(newUrl);
            }
        })
            .finally(() => setLoading(false));
    });
    const [fileUploading, setFileUploading] = useState(false);
    const [isOpenErrorModal, setIsOpenErrorModal] = useState(false);
    const intialErrorsData = {
        isValidated: true,
        companyErrors: [],
        contactErrors: [],
        objectCompanyErrors: [],
        objectErrors: [],
        objectTypeErrors: [],
        rolesErrors: [],
        systemInstalledErrors: [],
    };
    const [importErrors, setImportErrors] = useState(intialErrorsData);
    const closeModal = () => {
        setIsOpenErrorModal(false);
    };
    // Rows whose Safe-ID is already known (or repeated in the file) are discarded by the import.
    // Report the counts so a shrinking import is explained rather than mysterious (item #12).
    const showSafeIdImportSummary = (summary) => {
        if (!summary)
            return;
        const skipped = summary.rowsSkippedAlreadyKnown + summary.rowsSkippedDuplicateInFile;
        if (skipped === 0)
            return;
        toast.info(translate("ImportSafeIdSummary", {
            added: summary.companiesAdded,
            knownSkipped: summary.rowsSkippedAlreadyKnown,
            duplicateSkipped: summary.rowsSkippedDuplicateInFile,
        }));
    };
    const handleFileChange = (event) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const file = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (file) {
            var type = file.name.split(".")[1];
            if (type === "xlsx" || type === "xls") {
                setFileUploading(true);
                const formData = new FormData();
                formData.append("request", file);
                yield LeadsApi.importLeads(formData)
                    .then((res) => {
                    if (res && res.data) {
                        if (res.data.isValidated === true) {
                            toast.success("Leads zijn succesvol geüpload");
                            showSafeIdImportSummary(res.data.safeIdSummary);
                            setRefresh((prev) => !prev);
                        }
                        else {
                            setIsOpenErrorModal(true);
                            setImportErrors(res.data);
                        }
                    }
                    else {
                        toast.error("Upload een geldig formaatbestand of neem contact op met de beheerder");
                    }
                })
                    .finally(() => {
                    setFileUploading(false);
                    event.target.value = "";
                });
            }
            else {
                toast.error("Alleen xls, xlsx toegestaan.");
                event.target.value = "";
            }
        }
    });
    const handleChange = () => {
        setPaginationModel({ page: 0, pageSize: 15 });
        setIsSelectiveRoles((prev) => !prev);
    };
    const handleAutocompleteChange = (event, newValue) => {
        setPaginationModel({ page: 0, pageSize: 15 });
        setSelectedPerson(newValue);
    };
    // Controlled so a restored selection actually shows in the box (it used to be
    // uncontrolled with a hardcoded "All" default). Falls back to "All" while the
    // options are still loading or when the stored person is gone — the page drops
    // the stale id separately.
    const allOption = (_a = contactOptions.find((item) => item.id === "all")) !== null && _a !== void 0 ? _a : null;
    const selectedPersonOption = selectedPersonId
        ? (_b = contactOptions.find((item) => item.id === selectedPersonId)) !== null && _b !== void 0 ? _b : allOption
        : allOption;
    const handleUnAssignedChange = () => {
        setIsUnAssignedLeads((prev) => !prev);
        setPaginationModel({ page: 0, pageSize: 15 });
    };
    return (_jsxs(_Fragment, { children: [_jsx(Container, { disableGutters: true, sx: { maxWidth: "100% !important" }, children: _jsxs(Box, { children: [_jsxs(Box, { sx: {
                                padding: "24px 0px",
                                display: "flex",
                                justifyContent: "space-between",
                            }, children: [_jsx(Typography, { sx: { width: "50%", color: theme.palette.text.primary }, variant: "h1", children: title !== null && title !== void 0 ? title : "Verkoop" }), !hideActions && (_jsxs(Grid, { container: true, size: {
                                        xs: 12,
                                        md: 7
                                    }, sx: {
                                        gap: 2,
                                        justifyContent: "flex-end",
                                        "--Grid-parent-columns": 12,
                                        "--Grid-parent-columnSpacing": "0px"
                                    }, children: [_jsxs(Button, { variant: "outlined", component: "label", disabled: fileUploading, children: [fileUploading ? (_jsx(CircularProgress, { color: "inherit", size: 20 })) : (_jsx(DownloadSimple, { size: 24 })), _jsx("input", { type: "file", hidden: true, onChange: handleFileChange })] }), checkManage(RolesPermissions, Modules.Leads) && (_jsx(Button, { variant: "contained", size: "medium", startIcon: !loading && _jsx(UserCheck, { size: 24 }), onClick: handleOpenModal, sx: { marginRight: "5px" }, children: "Verkoop toewijzen" })), checkCreateEdit(RolesPermissions, Modules.Leads) && (_jsx(Button, { variant: "contained", size: "medium", startIcon: !loading && _jsx(Plus, {}), onClick: createNewLead, disabled: loading, children: loading ? (_jsx(CircularProgress, { size: 24, color: "inherit" })) : (translate("CreateLead")) }))] }))] }), _jsx(Box, { sx: {
                                padding: "16px 32px",
                                bgcolor: theme.palette.common.white,
                                borderRadius: "24px",
                            }, children: _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { size: {
                                            xs: 12,
                                            md: 4,
                                            xl: 3
                                        }, children: _jsx(FormControl, { fullWidth: true, variant: "outlined", size: "medium", children: _jsx(TextField, { id: "search", label: "Zoeken", value: searchInput, onChange: (e) => setSearchInput(e.target.value), onKeyDown: (e) => handleSearch(e), variant: "outlined", placeholder: "ID # , Klant , etc...", size: "medium", children: _jsx(SearchIconWrapper, { children: _jsx(SearchIcon, {}) }) }) }) }), _jsx(Grid, { size: {
                                            xs: 12,
                                            md: 4,
                                            xl: 2
                                        }, children: _jsxs(FormControl, { fullWidth: true, variant: "outlined", size: "medium", children: [_jsx(InputLabel, { children: "Status" }), _jsxs(Select, { labelId: "simple-select-label", id: "simple-select", label: "Status", defaultValue: 0, value: status !== 0 ? status : undefined, onChange: (e) => {
                                                        if (e.target.value === 0) {
                                                            setStatus(undefined);
                                                        }
                                                        else {
                                                            setStatus(e.target.value);
                                                        }
                                                    }, children: [_jsx(MenuItem, { value: 0, children: translate("All") }), getStatusOptionsForDropdown(status).map((statusOption) => (_jsxs(MenuItem, { value: statusOption.value, sx: statusOption.deprecated ? {
                                                                fontStyle: 'italic',
                                                                color: 'text.secondary',
                                                                '&:hover': {
                                                                    backgroundColor: 'action.hover'
                                                                }
                                                            } : {}, children: [translate(statusOption.translationKey), statusOption.deprecated && ` (${translate("Deprecated")})`] }, statusOption.value)))] })] }) }), _jsx(Grid, { size: {
                                            xs: 12,
                                            md: 4,
                                            xl: 2
                                        }, children: _jsx(Autocomplete, { disablePortal: true, id: "combo-box-demo", options: contactOptions, value: selectedPersonOption, isOptionEqualToValue: (optionItem, valueItem) => optionItem.id === valueItem.id, noOptionsText: translate("noOptions"), onChange: handleAutocompleteChange, renderInput: (params) => (_jsx(TextField, Object.assign({}, params, { label: "Selecteer verantwoordelijke" }))) }) }), _jsx(Grid, { size: {
                                            xs: 6,
                                            sm: 6,
                                            md: 6,
                                            xl: 2
                                        }, children: _jsx(FormGroup, { children: _jsx(FormControlLabel, { value: "bottom", control: _jsx(Switch, { checked: !isSelectiveRoles, onChange: () => handleChange() }), sx: {
                                                    "& .MuiFormControlLabel-label": {
                                                        textAlign: "center",
                                                        fontSize: {
                                                            xs: "0.7rem",
                                                            sm: "0.75rem",
                                                            md: "0.85rem",
                                                        },
                                                    },
                                                }, label: "Toon alle rollen", labelPlacement: "bottom" }) }) }), _jsx(Grid, { size: {
                                            xs: 6,
                                            sm: 6,
                                            md: 6,
                                            xl: 3
                                        }, children: _jsx(FormGroup, { children: _jsx(FormControlLabel, { value: "bottom", control: _jsx(Switch, { checked: isUnAssignedLeads, onChange: () => handleUnAssignedChange() }), sx: {
                                                    "& .MuiFormControlLabel-label": {
                                                        textAlign: "center",
                                                        fontSize: {
                                                            xs: "0.7rem",
                                                            sm: "0.75rem",
                                                            md: "0.85rem",
                                                        },
                                                    },
                                                }, label: "Niet-toegewezen leads", labelPlacement: "bottom" }) }) })] }) })] }) }), _jsx(ImportLeadsErrorModal, { open: isOpenErrorModal, onClose: closeModal, errors: importErrors })] }));
};
